import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=80a7491c&scoped=true&"
import script from "./UserPassword.vue?vue&type=script&lang=js&"
export * from "./UserPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserPassword.vue?vue&type=style&index=0&id=80a7491c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a7491c",
  null
  
)

export default component.exports